/*
 * @Author: Dong
 * @Date: 2022-04-06 15:05:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-09-06 17:18:10
 */
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { changeForm } from 'root/store/fileConfig/actions';
import { changeNodeForm } from 'root/store/nodeConfig/actions';

import { Spin, message } from 'sup-ui';
import { reducerStates } from 'root/store/types';
import TitleHeader from 'root/components/TitleHeader';
import Footer from 'root/components/InstallFooter';
import License from './License';
import FileConfig from 'root/components/ExtAndApp';
import CheckInstall from 'root/components/CheckInstall';
import Deploy from 'root/components/Deploy';
import Database from 'root/components/Database';
import InstallList from 'root/components/InstallList';
import Authorization from 'root/components/Authorization';

import { installData } from 'root/components/FileConfig/utils';
import {
  getSuposAllConfig,
  newGetSuposAllConfig,
  getUrl,
  install,
  modifySuposConfig,
  checkDatabaseConnection,
  checkSshConnection,
  setTenantApi,
} from 'root/services/manager';
import { checkExtPackApi } from 'root/services/packageManage';
import { InstallplatformInfoType, supOSConfigDataType } from './types';
import Modal from 'root/components/CommonModal';
import { useIntl } from 'react-intl';
import messages from './messages';
import styles from './index.less';
import CancelInstall from 'root/components/CancelInstall';
import { PackageDataType } from 'root/components/FileConfig/types';
import NodeConfig from 'root/components/NodeConfig';
const { confirm } = Modal;
interface CpuAndMemoryCheckRes {
  isMemoryExceed: boolean;
  isCpuExceed: boolean;
}
// license/协议  check/检测 deploy/部署配置  database/安装配置  fileConfig/配置文件  installList/安装

const Install = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  // 系统状态
  const { sysStatus } = useSelector((state: reducerStates) => state.common);
  const { selectedVersions, formData, systemInfo } = useSelector((state: reducerStates) => state.fileConfig);
  const { nodeVersions, nodeFormData, installationType, nodeData } = useSelector(
    (state: reducerStates) => state.nodeConfig,
  );
  const { isMultiTenant, domain } = useSelector((state: reducerStates) => state.tenant);

  // cpu和内存配额校验结果信息
  const [cpuAndMemoryCheckRes, setCpuAndMemoryCheckRes] = useState<CpuAndMemoryCheckRes>({
    isMemoryExceed: false,
    isCpuExceed: false,
  });
  const { cluster } = useSelector((state: reducerStates) => state.envManage);

  const steps = cluster
    ? ['license', 'fileConfig', 'nodeConfig', 'authorization', 'database', 'check', 'installList']
    : ['license', 'fileConfig', 'deploy', 'database', 'check', 'installList'];

  const [step, setStep] = useState(steps[0]);
  const deployRef = useRef<any>();
  const databaseRef = useRef<any>();
  const authorizationRef = useRef<any>();

  const [cancelModalVisble, setCancelModalVisble] = useState(false); // 模态框显示开关
  const [canceledSupos, setCanceledSupos] = useState(false); // 显示取消安装supos页面
  const [platformInfo, setPlatformInfo] = useState<InstallplatformInfoType>({ supos: { reservedPortsForWeb: [] } }); // 平台数据 supos信息和端口等
  const [supOSConfigData, setSupOSConfigData] = useState<supOSConfigDataType>({
    supos: {},
    database: {},
  });
  const [disabledNextStep, setDisabledNextStep] = useState(true); // 下一步按钮状态
  const [suposUrl, setSuposUrl] = useState(); // supOS访问地址
  const [spinning, setSpinning] = useState(false); //
  const [tip, setTip] = useState(''); // 检测数据库
  const [failMes, setFailMes] = useState(''); // 检测数据库
  const [failSshMes, setFailSshMes] = useState(''); // 检测SSH连接
  const { hosts } = useSelector((state: reducerStates) => state.nodeConfig);
  const [nodeParams, setNodeParams] = useState<any>([]); // 检测数据库
  const [webPort, setWebPort] = useState(''); // SUPOS端口号
  const [limitInfo, setLimitInfo] = useState({ memLimit: 0, cpuLimit: 0 }); // cup和Memory的最大值
  // 刷新浏览器显示二次确认
  useEffect(() => {
    // 协议页，不需要二次确认
    window.isBeforeunloadTip = step !== 'license';

    return () => {
      // 默认不显示二次确认
      window.isBeforeunloadTip = false;
    };
  }, [step]);

  // 安装中、安装失败，step默认直接跳到installList步骤
  useEffect(() => {
    if (sysStatus && ['doing', 'failure'].includes(sysStatus)) {
      setStep('installList');
    }
  }, [sysStatus]);

  // 加载每一步时的前置操作
  useEffect(() => {
    if (!stepsDidMount[step]) return;
    stepsDidMount[step]();
  }, [step]);
  const togglleModalVisble = () => {
    showModal();
  };
  // 更新cpu和内存校验状态
  const updateCpuAndMemoryCheckRes = (type: string, value: boolean) => {
    setCpuAndMemoryCheckRes({ ...cpuAndMemoryCheckRes, [type]: value });
  };
  // 点击确定
  const onOk = () => {
    window.isBeforeunloadTip = false;
    window.hashHistory.push('/instances');
  };
  const cancel = () => {
    setCancelModalVisble(false);
  };
  const showModal = () => {
    confirm({
      content: intl.formatMessage(messages.exitInstall),
      onOk: onOk,
      visible: cancelModalVisble,
      onCancel: cancel,
    });
  };
  // 获取supOS访问地址
  const getSuposUrl = () => {
    getUrl().then((res: any) => {
      const { data } = res;
      setSuposUrl(data);
    });
  };
  const stepsDidMount: { [x: string]: any } = {
    deploy: () => {
      getPlatformInfoFn();
    },
    authorization: () => {
      getPlatformInfoFn();
    },
    nodeConfig: () => {
      getPlatformInfoFn();
    },
    installList: getSuposUrl,
  };
  // 获取平台信息
  const getPlatformInfoFn = () => {
    const params = { product: systemInfo?.name };
    getSuposAllConfig(params).then(async (res: any) => {
      setPlatformInfo(res.data);
      // 把获取的信息放到缓存数据对象中
      Object.assign(res.data.supos, res.data.license);
      const obj = { ...supOSConfigData };
      // 设置limit信息  内存和cpu
      const suposData = res.data.supos;
      setLimitInfo({ cpuLimit: suposData.cpuLimit, memLimit: suposData.memLimit });

      // 区分supos中的sshPort  与 授权信息中的sshPort
      res.data.license['lincenseSSHPort'] = res.data.license.sshPort;
      delete res.data.license.sshPort;

      obj.supos = { ...res.data.license, ...res.data.supos, ...obj.supos };
      obj.supplant = res.data?.supPlant || {};
      await dbConfigTooldConfig(params).then((supOSConfig: any) => {
        obj.database = { ...supOSConfig.database, ...obj.database };
        obj.supos.OSLANG = supOSConfig.OSLANG;
        setSupOSConfigData({ ...obj });
        console.log('supos config -----', obj);
      });
    });
  };

  /**
   * 获取database配置，2023.5.18新增业务逻辑，获取数据库配置的
   * 后端定义所有返回为字符串
   *  */
  const dbConfigTooldConfig = async (params: any) => {
    const config = {
      database: {
        defaultDatabase: 0,
        type: '',
        host: '',
        port: '',
        name: '',
        oracleVersion: 'default',
        user: '',
        password: '',
      },
      OSLANG: 'zh_CN',
    };
    await newGetSuposAllConfig(params).then((supOSConfig: any) => {
      const { data } = supOSConfig;
      if (data.EXT_DB_ENABLED === 'true') {
        config.database = {
          defaultDatabase: 1,
          type: data.EXT_DB_TYPE,
          host: data.EXT_DB_HOST,
          port: data.EXT_DB_PORT,
          name: data.EXT_DB_NAME,
          oracleVersion: data.EXT_DB_VERSION,
          user: data.EXT_DB_USER,
          password: data.EXT_DB_PASS,
        };
      }
      if (data.RDS_ENABLE === 'true') {
        config.database = {
          defaultDatabase: 2,
          type: data.RDS_TYPE,
          host: data.RDS_HOST,
          port: data.RDS_PORT,
          name: data.RDS_DATABASE,
          oracleVersion: data.RDS_VERSION,
          user: data.RDS_USER,
          password: data.RDS_PASSWD,
        };
      }
      config.OSLANG = data.OSLANG;
    });
    return config;
  };

  // 提交平台配置信息 返回值为是否设置成功
  // eslint-disable-next-line complexity
  const postConfig = async (tempData: any) => {
    // 设置数据库配置
    let body: any = {};
    if (step === `deploy`) {
      const {
        appMem,
        appCpu,
        mem,
        cpu,
        webPort,
        host,
        user,
        password,
        sameServerWithOps,
        sshPort,
        lincenseSSHPort,
        licensingInstalled,
        OSLANG,
      } = tempData;

      body = {
        supos: {
          appMem,
          appCpu,
          mem,
          cpu,
          webPort,
          sshPort,
          reservedPortsForWeb: [],
          OSLANG,
        },
        license: {
          host,
          user,
          password,
          sshPort: lincenseSSHPort,
          sameServerWithOps,
          authInstalled: licensingInstalled,
        },
      };
    }

    //  设置授权
    if (step === `authorization`) {
      const { authorizedDogAddress1, authorizedDogAddress2 } = tempData;

      body = {
        license: {
          host: authorizedDogAddress2 ? `${authorizedDogAddress1},${authorizedDogAddress2}` : authorizedDogAddress1,
        },
      };
    }
    // 数据页需要添加相关信息
    if (step === `database`) {
      const database = tempData;
      database.oracleVersion = database.oracleVersion === '11g_r2' ? 'default' : database.oracleVersion;
      if (database.type) database.type = database.type.toLowerCase();
      body.database = database;
    }

    let flag = false;
    let sshFlag = true;

    // 如果授权信息不是同一台服务器 ssh测试连接
    if (!tempData.sameServerWithOps && !tempData.licensingInstalled && step === `deploy`) {
      const { host, user, password, lincenseSSHPort } = tempData;
      const params = {
        ip: host,
        user,
        password,
        port: lincenseSSHPort,
      };

      setSpinning(true);
      setTip(intl.formatMessage(messages.testLink));
      await checkSshConnection(params)
        .then((res: any) => {
          if (res?.data?.connected) {
            flag = true;
          }
          sshFlag = res?.data?.connected;
          setFailSshMes(res.data.cause);
        })
        .catch(() => {
          sshFlag = false;
        })
        .finally(() => {
          setSpinning(false);
          setTip('');
        });
    }

    // ssh测试连接失败直接返回
    if (!sshFlag) return false;

    //  如果是外置数据库，需要测试数据库连接
    if (tempData.defaultDatabase !== 0 && step === `database`) {
      const { host, port, user, password, type, name } = tempData;

      const params = {
        ip: host,
        port,
        username: user,
        password,
        dbType: type,
        dbName: name,
      };
      setSpinning(true);
      setTip(intl.formatMessage(messages.testLink));

      await checkDatabaseConnection(params)
        .then((res: any) => {
          if (res?.data?.connected) {
            flag = true;
          }
          setFailMes(res.data.cause);
        })
        .finally(() => {
          setSpinning(false);
          setTip('');
        });
    }

    // 外置数据库连接失败直接返回
    if (!flag && tempData.defaultDatabase !== 0 && step === `database`) return false;
    setSpinning(true);

    let productName = '';
    let params = {};

    // 2023年5月21日添加业务逻辑，当页面上选择了安装默认语言的时候现调用新的CONF接口进行提交语言，后端没有更改以前的接口逻辑，前端在不进行大调整的情况下进行了两次接口调用，后续可以全部逻辑进行调整
    if (body.supos) {
      productName = systemInfo?.name;
      const langBody = {
        OSLANG: body.supos.OSLANG,
      };
      await modifySuposConfig(langBody, productName).then(() => {
        productName = '';
      });
    }

    if (body.database) {
      productName = systemInfo?.name;
      params = {
        EXT_DB_ENABLED: body.database.defaultDatabase === 1 ? true : false,
        EXT_DB_TYPE: body.database.defaultDatabase === 1 ? body.database.type.toLowerCase() : '',
        EXT_DB_VERSION:
          body.database.defaultDatabase === 1 && body.database.type.toLowerCase() === 'oracle'
            ? body.database.oracleVersion
            : 'default',
        EXT_DB_NAME: body.database.defaultDatabase === 1 ? body.database.name : '',
        EXT_DB_HOST: body.database.defaultDatabase === 1 ? body.database.host : '',
        EXT_DB_PORT: body.database.defaultDatabase === 1 ? body.database.port : '',
        EXT_DB_USER: body.database.defaultDatabase === 1 ? body.database.user : '',
        EXT_DB_PASS: body.database.defaultDatabase === 1 ? body.database.password : '',
        RDS_ENABLE: body.database.defaultDatabase === 2 ? true : false,
        RDS_TYPE: body.database.defaultDatabase === 2 ? body.database.type.toLowerCase() : '',
        RDS_HOST: body.database.defaultDatabase === 2 ? body.database.host : '',
        RDS_PORT: body.database.defaultDatabase === 2 ? body.database.port : '',
        RDS_VERSION:
          body.database.defaultDatabase === 2 && body.database.type.toLowerCase() === 'oracle'
            ? body.database.oracleVersion
            : '',
        RDS_DATABASE: body.database.defaultDatabase === 2 ? body.database.name : '',
        RDS_USER: body.database.defaultDatabase === 2 ? body.database.user : '',
        RDS_PASSWD: body.database.defaultDatabase === 2 ? body.database.password : '',
        DLAKE_RES_CATALOG: body.database.defaultDatabase !== 2 ? 'sql' : 'rds',
        DLAKE_RES_SUBCATALOG: body.database.defaultDatabase !== 2 ? 'mariadb' : body.database.type.toLowerCase(),
        DLAKE_RES_INSTANCE: '',
      };
      body = params;
    }

    if (body?.supos?.webPort) setWebPort(body.supos.webPort);

    // 当大于cpu大于等于64c且内存大于等于125G时，使用32c、64g默认值，小于默认值确认框提示
    if (limitInfo.cpuLimit >= 64 && limitInfo.memLimit >= 125 && (body?.supos?.cpu < 32 || body?.supos?.mem < 64)) {
      confirm({
        title: intl.formatMessage(messages.limitTip),
        width: 500,
        onOk: async () => {
          handleModifySuposConfig(body, productName, () => {
            setStep('database');
          });
        },
        onCancel: () => {
          setSpinning(false);
        },
      });
      return;
    }

    flag = await handleModifySuposConfig(body, productName);
    return flag;
  };

  // 处理系统配置页面的更新config
  const handleModifySuposConfig = async (body: any, productName: string, callback?: () => void) => {
    let flag = false;
    await modifySuposConfig(body, productName)
      .then(() => {
        flag = true;
        if ([`deploy`, 'authorization'].includes(step)) {
          setSpinning(false);
        }
        if (callback) callback();
      })
      .catch(() => {
        setSpinning(false);
      });
    return flag;
  };

  // 校验安装包表单信息
  const validateForm = async () => {
    // step1:校验必选的是否选中
    let requireCheck = true;
    if (window.extForms) {
      Object.keys(window?.extForms)?.forEach((name: any) => {
        // 只校验选中组件的表单
        window.extForms[name].validateFields((err: any) => {
          if (err) {
            requireCheck = false;
            return;
          }
        });
      });
    }
    if (!requireCheck) return;

    // step2:校验选中的组件包自带的表单数据
    let isCheckPass = true;
    const data = selectedVersions;
    let params = installData(data, 'install');
    const form = { ...formData };
    // 校验表单
    if (window.moduleForms) {
      Object.keys(window?.moduleForms)?.forEach((name: any) => {
        // 只校验选中组件的表单
        if (!params?.find((item: any) => item.name === name)) return;

        window.moduleForms[name].validateFields((err: any, values: any) => {
          if (err) {
            isCheckPass = false;
            return;
          }

          // 把对应的表单信息添加到params中
          params = params?.map((i) => {
            if (i.name === name) {
              form[i.name] = { ...values };
              return { ...i, form: { ...values } };
            }
            return i;
          });
        });
      });
    }
    // 保存表单信息到store，用于返回上一步的时候回显
    if (!isCheckPass) return;

    //  step3:接口校验安装包依赖关系
    isCheckPass = await checkDependencies(params);
    dispatch(changeForm(form));
    // 校验不通过，不进行安装
    return isCheckPass;
  };

  // 检查安装包依赖关系
  const checkDependencies = async (params: any) => {
    let result = false;
    params.push({ name: 'supos', archiveId: systemInfo.archiveId });
    await checkExtPackApi(params).then((res) => {
      const { data } = res;
      if (!data || !data.length) {
        result = true;
        return;
      }
      data.forEach((item: any) => {
        const { name, dependName, errorType } = item;
        Object.keys(window?.extForms)?.forEach((extName: any) => {
          // 校验依赖的扩展服务
          if (dependName === extName) {
            // errorType:1 被依赖组件为空  2 被依赖组件版本不支持
            if (errorType === 1) {
              window.extForms[dependName].setFields({
                version: { value: '', errors: [new Error(intl.formatMessage(messages.dependNullTip, { type: name }))] },
              });
            }
            if (errorType === 2) {
              window.extForms[dependName].setFields({
                version: {
                  value: selectedVersions[dependName],
                  errors: [new Error(intl.formatMessage(messages.dependVerisonTip, { type: name }))],
                },
              });
              window.extForms[name].setFields({
                version: {
                  value: selectedVersions[name],
                  errors: [new Error(intl.formatMessage(messages.selectVerisonTip, { type: dependName }))],
                },
              });
            }
          }
        });
      });
    });

    return result;
  };

  // 验证表单处理函数
  const handleNext = async () => {
    let flag: any = true;
    let tempData: any = {}; // 临时存的本页数据

    if (step === 'fileConfig') {
      flag = await validateForm();
    }
    if (step === `deploy` && deployRef.current) {
      const form = deployRef.current.form;
      form.validateFields(async (err: any, values: any) => {
        if (err || cpuAndMemoryCheckRes.isCpuExceed || cpuAndMemoryCheckRes.isMemoryExceed) {
          flag = false;
          return;
        }
        const obj = { ...supOSConfigData };
        obj.supos = { ...obj.supos, ...values };
        setSupOSConfigData({ ...obj });
        tempData = values;
      });
      flag = flag ? await postConfig(tempData) : false;
      flag = flag ? await setTenant() : false;
    }

    if (step === `authorization` && authorizationRef.current) {
      const form = authorizationRef.current.form;

      form.validateFields(async (err: any, values: any) => {
        if (err) {
          flag = false;
          return;
        }
        const obj = { ...supOSConfigData };
        obj.supos = values;
        setSupOSConfigData({ ...obj });
        tempData = values;
      });
      if (!flag) return;
      flag = await postConfig(tempData);
      flag = await setTenant();
      flag = await setLanguage(tempData.OSLANG);
    }

    // 判断是否是安装配置页面，如果是点击下一步验证其表单并保存数据
    if (step === `database` && databaseRef.current) {
      databaseRef.current.form.validateFields((err: any, values: any) => {
        if (err) {
          flag = false;
          return;
        }
        const obj = { ...supOSConfigData };
        obj.database = values || {};
        setSupOSConfigData({ ...obj });
        tempData = values;
      });
      flag = flag ? await postConfig(tempData) : false;
      setSpinning(false);
    }
    // 安装前检查
    if (step === 'check') {
      setSpinning(true);
      flag = await startInstall();
    }
    return flag;
  };
  // 保存当前页面数据
  const handlePrev = async () => {
    // 判断是否是部署配置页面，如果是点击上一步保存数据
    if (step === `deploy` && deployRef.current) {
      deployRef.current.form.validateFields((err: any, values: any) => {
        const obj = { ...supOSConfigData };
        obj.supos = values;
        setSupOSConfigData({ ...obj });
      });
    }

    // 判断是否是授权配置页面，如果是点击上一步保存数据
    if (step === `authorization` && authorizationRef.current) {
      authorizationRef.current.form.validateFields((err: any, values: any) => {
        const obj = { ...supOSConfigData };
        obj.supos = values;
        setSupOSConfigData({ ...obj });
      });
    }

    // 判断是否是安装配置页面，如果是点击下一步保存数据
    if (step === `database` && databaseRef.current) {
      databaseRef.current.form.validateFields((err: any, values: any) => {
        const obj = { ...supOSConfigData };
        obj.database = values;
        setSupOSConfigData({ ...obj });
      });
    }
  };

  // 设置租户
  const setTenant = async () => {
    let result = false;
    const param: any = {
      isMultiTenant,
      domain,
    };
    await setTenantApi(param).then(() => {
      result = true;
    });
    return result;
  };

  //  集群环境设置supos默认语言
  const setLanguage = async (OSLANG: string) => {
    let result = false;
    let productName = '';
    productName = systemInfo?.name;
    const langBody = {
      OSLANG,
    };
    await modifySuposConfig(langBody, productName).then(() => {
      productName = '';
      result = true;
    });
    return result;
  };

  // 获取安装参数
  const getInstallParams = () => {
    const data = { ...selectedVersions, supos: systemInfo.archiveId };
    let params: any = installData(data, 'install');

    // supos安装版本、扩展服务信息
    if (cluster) params = [...params, ...nodeParams];

    // 把对应的表单信息添加到params中
    params = params.filter((item: any) => {
      const { name } = item;
      // 删除k8s中间件包
      if (['k8s-master', 'k8s-worker-app', 'k8s-worker'].includes(name)) return null;

      // 删除内置中间件
      if (installationType[name] === 2) {
        delete hosts[name];
        return null;
      }

      if (formData[name]) {
        item.form = formData[name];
      }

      if (nodeFormData[name]) {
        item.form = nodeFormData[name];
      }
      if (installationType[name]) {
        item.installMode = installationType[name];
      }

      return item;
    });

    return { modules: params, hosts };
  };

  // 开始安装
  const startInstall = async () => {
    const body = getInstallParams();
    const result = await install(body).catch(() => {
      setSpinning(false);
    });

    // 重置按钮状态
    setDisabledNextStep(true);
    await new Promise((resolve) => {
      setTimeout(() => {
        setSpinning(false);
        resolve('sleep');
      }, 2000);
    });

    return result;
  };
  // 校验节点配置
  const nodeConfigVerify = async () => {
    // 检查节点是否满足安装需求
    const nodeArr: any = [];
    nodeData.forEach((item: any) => {
      const { labelName, nowNum, shouldNum } = item;
      // 检查是独立节点安装并且当前节点数量没有少于需要节点数量
      if (installationType[labelName] === 1 && nowNum < shouldNum) {
        nodeArr.push(labelName);
      }
    });
    if (nodeArr.length) {
      message.error(nodeArr.join('、') + intl.formatMessage(messages.nodeCountTip));
      return;
    }

    // step1:校验必选的是否选中
    let requireCheck = true;
    if (window.nodeForms) {
      Object.keys(window?.nodeForms)?.forEach((name: any) => {
        // 只校验选中组件的表单
        window.nodeForms[name].validateFields((err: any) => {
          if (err) {
            requireCheck = false;
            return;
          }
        });
      });
    }
    if (!requireCheck) return;

    // step2:校验选中的组件包自带的表单数据
    let isCheckPass = true;
    const data = nodeVersions;
    let params = installData(data, 'install');
    const form = { ...nodeFormData };

    // 校验表单
    if (window.ndeConfigForms) {
      Object.keys(window?.ndeConfigForms)?.forEach((name: any) => {
        // 只校验选中组件的表单
        if (!params?.find((item: any) => item.name === name)) return;

        window.ndeConfigForms[name].validateFields((err: any, values: any) => {
          if (err) {
            isCheckPass = false;
            return;
          }

          // 把对应的表单信息添加到params中
          params = params?.map((i) => {
            if (i.name === name) {
              form[i.name] = { ...values };
              return { ...i, form: { ...values } };
            }
            return i;
          });
        });
      });
    }
    // 保存表单信息到store，用于返回上一步的时候回显
    if (!isCheckPass) return;
    dispatch(changeNodeForm(form));

    setNodeParams(params);

    // 校验不通过，不进行安装
    return isCheckPass;
  };

  // 跳转页面下一步的后置操作
  const stepsHandle: { [key: string]: any } = {
    fileConfig: handleNext,
    deploy: handleNext,
    database: handleNext,
    authorization: handleNext,
    nodeConfig: nodeConfigVerify,
    check: handleNext,
  };
  // 点击下一步按钮的处理
  const stepAdd = async () => {
    // 下一步的序号
    const nextIndex = steps.indexOf(step) + 1;
    // 部署配置、安装配置，需要校验表单，校验通过方可进入下一步
    if (stepsHandle[step]) {
      const result = await stepsHandle[step]();
      if (!result) return;
    }
    // 跳转到下一步
    if (nextIndex > steps.length) return;
    setStep(steps[nextIndex]);
  };
  // 跳转到下上一步
  const prevStep = () => {
    const prevIndex = steps.indexOf(step) - 1;
    setStep(steps[prevIndex]);
    handlePrev();
  };

  // 安装状态全部结束，并且supos安装成功
  const updateQueueChange = (queues: PackageDataType[]) => {
    if (!queues.length) return;
    const isFinish = queues.every((item) => {
      // 如果有supos，则supos要保证安装成功
      if (item.name === 'supos') {
        return ['running', 'run_with_high_risk', 'run_with_low_risk'].includes(item.status?.toLocaleLowerCase() || '');
      }

      // 否则，只要任务结束，不管成功失败
      return item.status?.toLocaleLowerCase() !== 'waiting' && !item.percent;
    });

    if (disabledNextStep !== isFinish) return;
    setDisabledNextStep(!isFinish);
  };
  // 取消安装supos回调
  const handleCancelSupos = () => {
    setCanceledSupos(true);
  };
  // 结构中间根据步骤显示对应组件
  const components: { [x: string]: React.ReactNode } = {
    license: <License stepAdd={stepAdd} cancelFn={togglleModalVisble} supOSConfigData={supOSConfigData} />,
    check: <CheckInstall stepAdd={stepAdd} webPort={webPort} getInstallParams={getInstallParams} />,
    deploy: (
      <Deploy
        wrappedComponentRef={deployRef}
        platformInfo={platformInfo}
        supOSConfigData={supOSConfigData}
        updateCpuAndMemoryCheckRes={updateCpuAndMemoryCheckRes}
        failMes={failSshMes}
      />
    ),
    authorization: (
      <Authorization
        wrappedComponentRef={authorizationRef}
        platformInfo={platformInfo}
        supOSConfigData={supOSConfigData}
        updateCpuAndMemoryCheckRes={updateCpuAndMemoryCheckRes}
        failMes={failSshMes}
      />
    ),
    database: <Database wrappedComponentRef={databaseRef} supOSConfigData={supOSConfigData} failMes={failMes} />,
    fileConfig: <FileConfig />,
    nodeConfig: <NodeConfig />,
    installList: (
      <div>
        <InstallList
          updateQueueChange={updateQueueChange}
          canceledSupos={handleCancelSupos}
          showSupOS={true}
          showExtendedService={true}
        />
      </div>
    ),
  };
  const Main = () => {
    return components[step];
  };
  let sty;
  if (step === 'installList') {
    sty = { border: 'none' };
  } else if (step === 'deploy') {
    sty = { padding: '0px', border: 'none' };
  }

  return (
    <div
      className={
        ['license', 'check'].includes(step)
          ? `${styles.container} ${styles.guideBlack}`
          : `${styles.container} ${styles.installBg} `
      }
    >
      {spinning && <Spin className={styles.spin} tip={tip} />}
      {canceledSupos ? (
        <CancelInstall />
      ) : (
        <>
          {!['license', 'check'].includes(step) ? <TitleHeader step={step} /> : null}
          <div className={`${styles.inner} ${styles[step]}`}>
            <div
              className={
                ['license', 'check', 'installList', 'nodeConfig'].includes(step) ? styles.checkBox : styles.flexCenter
              }
              style={sty}
            >
              {Main()}
            </div>
          </div>
          <div className={styles.temp} />
          {!['license', 'check'].includes(step) ? (
            <Footer
              step={step}
              stepAdd={stepAdd}
              suposUrl={suposUrl}
              cancelFn={togglleModalVisble}
              prevStep={prevStep}
              disabled={disabledNextStep}
            />
          ) : null}
        </>
      )}
    </div>
  );
};
export default Install;
